export const routerEvaluacion = [
  {
    path: '/evaluacion/:idEvaluacion',
    name: 'evaluacion-instrucciones',
    component: () => import(/* webpackChunkName: "evaluacion-instrucciones" */ '../instrucciones.vue'),
  },
  {
    path: '/evaluacion/ejecucion/:idEvaluacion',
    name: 'evaluacion-ejecucion',
    component: () => import('../EvaluacionEjecucion.vue')
  }
]